import React, { useContext, useState } from 'react';
import { useUploadFile } from '../api/uploadFile';
import { fileUploadInitialFormData } from '../data/fileUploadData';
import { BillingUploadContext } from '../BillingUploadContext';

export const useFileUpload = () => {
  const billingUploadCtx = useContext(BillingUploadContext);
  
  const [file, setFile] = useState<File | null>(null);

  const uploadedFile = new FormData();
  if (file) {
    uploadedFile.append('file', file);
  }

  const uploadFileMutation = useUploadFile({uploadedFile,
    formParameters: fileUploadInitialFormData,
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  const handleUpload = () => {
    try {
      if (file) {
        const formParameters = billingUploadCtx.userFormData ? billingUploadCtx.userFormData  : fileUploadInitialFormData;

        uploadFileMutation.mutateAsync({
          uploadedFile,
          formParameters: formParameters
        }).then(() => {
          billingUploadCtx.handleChangeStatus("blocked");
        }).catch((error)=>{
          console.log(error)
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isLoading = uploadFileMutation.isLoading;
  const isError = uploadFileMutation.isError;
  const isSuccess = uploadFileMutation.isSuccess;

  return {
    handleFileChange,
    handleUpload,
    isLoading,
    isError,
    isSuccess
  }
}